
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import TableAHSF from "../../../../Components/TableAHSF";
import Swal from "sweetalert2";
import { decryptToken } from "../../../../Services/Encryption/EncryptionParams";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import InputAHSF from "../../../../Components/InputAHSF";
import TextAreaAHSF from "../../../../Components/TextAreaAHSF";
import { GetItemType } from "../../../../Redux/Reducers/Submitter/WPBItemType";
import ButtonAHSF from "../../../../Components/ButtonAHSF";
import './style.css'
import { AddContributionOfSecondTeam, EditContributionOfSecondTeam, GetContributionOfSecondTeamById, GetItemTypeForContributionOfSecondTeams, GetSupportTypeForContributionOfSecondTeam } from "../../../../Redux/Reducers/Submitter/ContributionOfSecondTeam";
import $ from "jquery";
import { GetObjectivesAndActivitiesDropDown } from "../../../../Redux/Reducers/Submitter/ObjectivesAndActivities";


const ContributionOfSecondTeamAdd = (props) => {
    const dispatch = useDispatch()
    const ContributionOfSecondTeam = useSelector((state) => state.ContributionOfSecondTeamReducers.ContributionOfSecondTeam)
    const ObjectivesAndActivities = useSelector((state) => state.ObjectivesAndActivitiesReducers.ObjectivesAndActivitiesDropDown)

    const ItemTypeForContribution = useSelector((state) => state.ContributionOfSecondTeamReducers.ItemTypeForContribution)
    const SupportTypeForContributionOfSecondTeam = useSelector((state) => state.ContributionOfSecondTeamReducers.SupportTypeForContributionOfSecondTeam)


    const [ItemName, setItemName] = useState(null)
    const [ItemDesecrabtion, setItemDesecrabtion] = useState(null)
    const [NumberOfunit, setNumberOfunit] = useState(null)
    const [UnitPrice, setUnitPrice] = useState(null)
    const [Facilities, setFacilities] = useState(null)
    const [ObjectivesAndActivitiesId, setObjectivesAndActivitiesId] = useState(null)
    const [SupportTypeForContributionOfSecondTeamId, setSupportTypeForContributionOfSecondTeamId] = useState(null)
    const [ItemTypeForContributionOfSecondTeamId, setItemTypeForContributionOfSecondTeamId] = useState(null)
    const [Total, setTotal] = useState(null)


    const [ItemNameValidation, setItemNameValidation] = useState(false)
    const [ItemDesecrabtionValidation, setItemDesecrabtionValidation] = useState(false)
    const [NumberOfunitValidation, setNumberOfunitValidation] = useState(false)
    const [UnitPriceValidation, setUnitPriceValidation] = useState(false)
    const [FacilitiesValidation, setFacilitiesValidation] = useState(null)

    const [SupportTypeForContributionOfSecondTeamIdValidation, setSupportTypeForContributionOfSecondTeamIdValidation] = useState(null)
    const [ItemTypeForContributionOfSecondTeamIdValidation, setItemTypeForContributionOfSecondTeamIdValidation] = useState(null)
    const [ObjectivesAndActivitiesIdValidation, setObjectivesAndActivitiesIdValidation] = useState(null)

    // const [Total, setTotal] = useState(null)

    const validation = () => {
        let validation = true;
        if (ItemName == null || ItemName == "") {
            setItemNameValidation(true)
            validation = false
        } else {
            setItemNameValidation(false)

        }
        if (ItemDesecrabtion == null || ItemDesecrabtion == "") {
            setItemDesecrabtionValidation(true)
            validation = false

        } else {
            setItemDesecrabtionValidation(false)

        }
        if (NumberOfunit == null || NumberOfunit == "") {
            setNumberOfunitValidation(true)
            validation = false

        } else {
            setNumberOfunitValidation(false)

        }
        if (UnitPrice == null || UnitPrice == "") {
            setUnitPriceValidation(true)
            validation = false

        } else {
            setUnitPriceValidation(false)

        }
        if (Facilities == null || Facilities == "") {
            setFacilitiesValidation(true)
            validation = false

        } else {
            setFacilitiesValidation(false)

        }

        if (ObjectivesAndActivitiesId == null || ObjectivesAndActivitiesId == "") {
            setObjectivesAndActivitiesIdValidation(true)
            validation = false

        } else {
            setObjectivesAndActivitiesIdValidation(false)

        }

        if (SupportTypeForContributionOfSecondTeamId == null || SupportTypeForContributionOfSecondTeamId == "") {
            setSupportTypeForContributionOfSecondTeamIdValidation(true)
            validation = false

        } else {
            setSupportTypeForContributionOfSecondTeamIdValidation(false)

        }

        if (ItemTypeForContributionOfSecondTeamId == null || ItemTypeForContributionOfSecondTeamId == "") {
            setItemTypeForContributionOfSecondTeamIdValidation(true)
            validation = false

        } else {
            setItemTypeForContributionOfSecondTeamIdValidation(false)

        }
        return validation
    }

    useEffect(() => {
        dispatch(GetObjectivesAndActivitiesDropDown({ ApplicationInformationId: localStorage.getItem("ApplicationInformationId") }))
        dispatch(GetItemTypeForContributionOfSecondTeams())
        dispatch(GetSupportTypeForContributionOfSecondTeam())

    }, [])

    const AddItemsRequestedFromSomanAdd = () => {
        if (validation()) {
            dispatch(AddContributionOfSecondTeam({
                itemName: ItemName,
                itemDescription: ItemDesecrabtion,
                numberOfUnits: parseFloat(NumberOfunit),
                facilities: Facilities,
                unitPrice: parseFloat(UnitPrice),
                SupportTypeForContributionOfSecondTeamId: SupportTypeForContributionOfSecondTeamId,
                ItemTypeForContributionOfSecondTeamId: ItemTypeForContributionOfSecondTeamId,
                objectivesAndActivitiesId: ObjectivesAndActivitiesId,
                total: parseFloat(UnitPrice * NumberOfunit),
                applicationInformationId: localStorage.getItem("ApplicationInformationId")
            }))
            Swal.fire({
                position: "center",
                icon: "success",
                title: "تمت الأضافة بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
            $(".close-btn").trigger("click");
        }

    }

    useEffect(() => {

        if (props.Action == "edit") {
            console.log(props.contributionOfSecondTeamId, "scscsc");

            dispatch(GetContributionOfSecondTeamById({ contributionOfSecondTeamId: props.contributionOfSecondTeamId }))
        }
    }, [props.contributionOfSecondTeamId])
    console.log(ContributionOfSecondTeam, "msmncmsncnmsc");


    useEffect(() => {
        if (props.ViewData) {
            setItemName(ContributionOfSecondTeam.itemName);
            setItemDesecrabtion(ContributionOfSecondTeam.itemDescription)
            setNumberOfunit(ContributionOfSecondTeam.numberOfUnits)
            setUnitPrice(ContributionOfSecondTeam.unitPrice)

        }
    }, [])

    const EditItemsRequestedFromSomanAdd = () => {
        if (validation()) {
            dispatch(EditContributionOfSecondTeam({
                contributionOfSecondTeamId: ContributionOfSecondTeam.contributionOfSecondTeamId,
                itemName: ItemName,
                itemDescription: ItemDesecrabtion,
                numberOfUnits: parseFloat(NumberOfunit),
                facilities: Facilities,
                SupportTypeForContributionOfSecondTeamId: SupportTypeForContributionOfSecondTeamId,
                ItemTypeForContributionOfSecondTeamId: ItemTypeForContributionOfSecondTeamId,
                objectivesAndActivitiesId: ObjectivesAndActivitiesId,
                unitPrice: parseFloat(UnitPrice),
                total: parseFloat(UnitPrice * NumberOfunit),
                applicationInformationId: localStorage.getItem("ApplicationInformationId")
            }))
            Swal.fire({
                position: "center",
                icon: "success",
                title: "تم التعديل بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
            $(".close-btn").trigger("click");
        }

    }



    useEffect(() => {
        if (props.Action == "edit") {
            setItemName(ContributionOfSecondTeam?.itemName)
            setItemDesecrabtion(ContributionOfSecondTeam?.itemDescription)
            setNumberOfunit(ContributionOfSecondTeam?.numberOfUnits)
            setUnitPrice(ContributionOfSecondTeam?.unitPrice)
            setFacilities(ContributionOfSecondTeam?.facilities)
            setObjectivesAndActivitiesId(ContributionOfSecondTeam?.objectivesAndActivitiesId)
            setSupportTypeForContributionOfSecondTeamId(ContributionOfSecondTeam?.supportTypeForContributionOfSecondTeamId)
            setItemTypeForContributionOfSecondTeamId(ContributionOfSecondTeam?.itemTypeForContributionOfSecondTeamId)
        }

    }, [ContributionOfSecondTeam])


    const HTML = <>
        <div className="ContainerContributionOfSecondTeam">

        </div>
        <div className="SectionOne">
            <InputAHSF
                fieldsName="Facilities"
                show={true}
                disabled={props.shouldDisableFields}
                onChange={(e) => {
                    setFacilities(e.target.value);
                }}
                showValidationMessage={FacilitiesValidation}
                defaultValue={props.ViewData ? ContributionOfSecondTeam?.facilities
                    : ""}
                validationMessage={"حقل اجباري"}
            />
            <AllDropDownsAHSF
                fieldsName="SupportTypeField"
                show={true}
                disabled={props.shouldDisableFields}

                dropdownType="normal"
                arrayOoptionList={SupportTypeForContributionOfSecondTeam}
                KeyText={"supportTypeForContributionOfSecondTeamName"}
                KeyValue={"supportTypeForContributionOfSecondTeamId"}
                defaultValue={props.ViewData ? ContributionOfSecondTeam?.supportTypeForContributionOfSecondTeamId
                    : ""}
                onChange={(e) => {
                    console.log(e, "dsfsdfsdfsdfeeeee");

                    setSupportTypeForContributionOfSecondTeamId(e.target.value)
                }}
                showValidationMessage={
                    SupportTypeForContributionOfSecondTeamIdValidation
                }
                validationMessage="يرجى تعبئة هذا الحقل"
            />

            <AllDropDownsAHSF
                fieldsName="ActivityRelatedToThisItem"
                show={true}
                disabled={props.shouldDisableFields}

                dropdownType="normal"
                arrayOoptionList={ObjectivesAndActivities}
                KeyText={"activities"}
                KeyValue={"objectivesAndActivitiesId"}
                defaultValue={props.ViewData ? ContributionOfSecondTeam?.objectivesAndActivitiesId
                    : ""}
                onChange={(e) => {
                    console.log(e, "dsfsdfsdfsdfeeeee");

                    setObjectivesAndActivitiesId(e.target.value)
                }}
                showValidationMessage={
                    ObjectivesAndActivitiesIdValidation
                }
                validationMessage="يرجى تعبئة هذا الحقل"
            />

        </div>

        <div className="Sectiontow">
            <AllDropDownsAHSF
                fieldsName="itemTypeField"
                show={true}
                disabled={props.shouldDisableFields}

                dropdownType="normal"
                arrayOoptionList={ItemTypeForContribution}
                KeyText={"itemTypeForContributionOfSecondTeamName"}
                KeyValue={"itemTypeForContributionOfSecondTeamId"}
                defaultValue={props.ViewData ? ContributionOfSecondTeam?.itemTypeForContributionOfSecondTeamId
                    : ""}
                onChange={(e) => {

                    setItemTypeForContributionOfSecondTeamId(e.target.value)
                }}
                showValidationMessage={
                    ItemTypeForContributionOfSecondTeamIdValidation
                }
                validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
                fieldsName="ItemName"
                show={true}
                disabled={props.shouldDisableFields}

                onChange={(e) => {
                    setItemName(e.target.value);
                }}
                showValidationMessage={ItemNameValidation}
                defaultValue={props.ViewData ? ContributionOfSecondTeam?.itemName
                    : ""}
                validationMessage={"حقل اجباري"}
            />

            <TextAreaAHSF
                fieldsName="ItemDescription"
                show={true}
                disabled={props.shouldDisableFields}

                defaultValue={props.ViewData ? ContributionOfSecondTeam?.itemDescription
                    : ""}

                onChange={(e) => {
                    setItemDesecrabtion(e.target.value);
                }}
                showValidationMessage={
                    ItemDesecrabtionValidation
                }
                validationMessage="يرجى تعبئة هذا الحقل"
            />
        </div>

        <div className="Sectionthree">
            <InputAHSF
                fieldsName="NumberOfUnits"
                show={true}
                comma={true}
                disabled={props.shouldDisableFields}

                defaultValue={props.ViewData ? ContributionOfSecondTeam?.numberOfUnits

                    : ""}
                onChange={(e) => {

                    setNumberOfunit(e.target.value);


                }}
                showValidationMessage={NumberOfunitValidation}
                validationMessage={"حقل اجباري"}
            />
            <InputAHSF
                fieldsName="UnitPrice"
                show={true}
                comma={true}
                disabled={props.shouldDisableFields}

                defaultValue={props.ViewData ? ContributionOfSecondTeam?.unitPrice : ""}
                onChange={(e) => {

                    setUnitPrice(e.target.value);

                }}
                showValidationMessage={UnitPriceValidation}
                validationMessage={"حقل اجباري"}
            />
            <InputAHSF
                value={UnitPrice * NumberOfunit}
                fieldsName="Total"
                show={true}
                disabled={true}
                onChange={(e) => {

                }}
                showValidationMessage={false}
                validationMessage={"حقل اجباري"}
            />
        </div>


        {
            props.shouldDisableFields ?
                <>

                </> : <>

                    <div className="ConainerButtonAHSF">
                        <ButtonAHSF
                            onClick={
                                props.Action == "edit" ? EditItemsRequestedFromSomanAdd : AddItemsRequestedFromSomanAdd
                            }
                            text={"حفظ"}
                            show={true}
                        />
                    </div>
                </>
        }


    </>
    return (
        <>
            {
                props.Action == "edit" ? ContributionOfSecondTeam?.itemTypeForContributionOfSecondTeamId&&ItemTypeForContribution&&ObjectivesAndActivities&&SupportTypeForContributionOfSecondTeam ? HTML : <></> : HTML
            }
        </>

    )
}

export default ContributionOfSecondTeamAdd